import type { OpportunityStatus, SingleOpportunity } from '@ps/isp-web-services-types';

import { type Entity, sportsSelection } from '../entities';
import { buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent, getEntities } from '../utils';

import { getIsAvailableOpportunity } from './utils/getIsOpportunity';
import { getRunnerStatus } from './utils/getRunnerStatus';

export const selectionsCleared = (
  context: TrackingContextValue,
  singleOpportunities: SingleOpportunity[]
) => {
  const entities: Entity[] = singleOpportunities.map((single) => {
    const selectionOdds = getIsAvailableOpportunity(single)
      ? single.winRunnerOdds?.decimalDisplayOdds?.decimalOdds
      : undefined;

    const selectionEntity = sportsSelection({
      selectionId: single.runnerId.selectionId,
      selectionOdds,
      selectionStatus: getRunnerStatus(single.status as OpportunityStatus),
      isStartingPrice: !selectionOdds
    });

    return selectionEntity;
  });

  const clearBetSlipContext = {
    category: context.category,
    widget: context.widget,
    entities: [...getEntities(context), ...entities]
  };

  GAEvent({ action: 'Clear Bet Slip' }, clearBetSlipContext);
  buttonClick({ buttonName: 'Clear Bet Slip' }, clearBetSlipContext);
};
